<div class="cart">

  @if (!items || !items.length) {
    <div class="cart__no-items">
      {{ 'cart.empty' | translate }}
    </div>
  } @else {
    <div class="cart__info">
      <div class="cart__prices">
        @if (prices.discountValue; as discountValue) {
          <div class="cart__price">
            <div class="cart__price-label">{{ 'global.items_cost' | translate }}:</div>
            <div class="cart__price-value">{{ prices.itemsCost }} {{ 'global.uah' | translate }}</div>
          </div>
          <div class="cart__price">
            <div class="cart__price-label">
              {{ 'global.discount' | translate }}:
            </div>
            <div class="cart__price-value cart__price-value--discount">-{{ discountValue }} {{ 'global.uah' | translate }}</div>
          </div>
        }
        <div class="cart__price cart__price--total">
          <div class="cart__price-label">{{ 'global.total_cost' | translate }}:</div>
          <div class="cart__price-value cart__price-value--total">{{ prices.totalCost }} {{ 'global.uah' | translate }}</div>
        </div>
      </div>
      <div class="cart__btns">
        @if (canPlaceOrder) {
          <a
            class="cart__btn cart__btn--checkout btn btn--default"
            (click)="checkout()"
            routerLink="/checkout"
            routerLinkWithLang
          >
            {{ 'cart.checkout' | translate }} <i class="cart__btn-icon mbi mbi-arrow-right"></i>
          </a>
        }
        @if (!canPlaceOrder) {
          <div class="cart__btn cart__cost-error">
            {{ 'global.minimal_order_cost' | translate }}: {{ minimalOrderCost }} {{ 'global.uah' | translate }}.
          </div>
        }
        <button class="cart__btn cart__btn--continue btn" (click)="continueShopping()">
          {{ 'cart.resume_shopping' | translate }}
        </button>
      </div>
    </div>
    <div class="cart__items" [class.cart__items--loading]="isLoading">
      @if (cartError; as error) {
        <div class="cart__error">
          {{ error }}
        </div>
      }
      @for (item of items; track item; let i = $index) {
        <div class="item">
          <div class="item__column">
            <div class="item__row item__row--info">
              <div class="item__img-container">
                <img class="item__img" [src]="setItemImg(item)" alt="" loading="lazy">
              </div>

              <div class="item__content">
                <a class="item__name main-link" [routerLink]="['/', item.slug]" routerLinkWithLang>
                  {{ item.name }}
                  @if (item.isLargeSized) {
                    <span class="item__is-large-size-label"> (крупногабаритн.)</span>
                  }
                </a>

                <div class="item__sku">
                  {{ 'global.sku' | translate }}: {{ item.sku }}
                </div>
              </div>
            </div>
          </div>
          <div class="item__column">
            <div class="item__row item__row--cost">
              <div class="item__price-container"
                [class.item__price-container--hidden]="item.price === item.cost && getActivePriceIndex(item) === undefined"
                >
                <div class="item__price"
                  [class.item__price--inactive]="getActivePriceIndex(item) !== undefined"
                  >
                  {{ item.price }} {{ 'global.uah' | translate }}
                </div>
                @if (item.oldPrice) {
                  <div class="item__old-cost">
                    {{ item.oldPrice }}
                  </div>
                }
              </div>
              <div class="item__qty-container">
                <quantity-control class="item__qty"
                  [initialValue]="item.qty"
                  (valueChanged)="onQtyChange(item, $event)"
                ></quantity-control>
              </div>
              <div class="item__cost-container">
                <div class="item__cost item__cost--no-discount">
                  @if (!getItemCostWithDiscount(item)) {
                    <div class="item__cost"
                      [class.item__cost--special]="item.oldCost"
                      >
                      {{ item.cost }} {{ 'global.uah' | translate }}
                    </div>
                  }
                  @if (item.oldCost) {
                    <div class="item__old-cost">
                      {{ item.oldCost }} {{ 'global.uah' | translate }}
                    </div>
                  }
                </div>
                @if (getItemCostWithDiscount(item)) {
                  <div class="item__cost item__cost--discount">
                    {{ getItemCostWithDiscount(item) }} {{ 'global.uah' | translate }}
                  </div>
                }
              </div>
            </div>
            <div class="item__row item__row--discount">
              <div class="discount">
                @if (!item.oldPrice) {
                  <ul class="item__discount-price-container discount">
                    @for (price of item.discountedPrices; track price; let i = $index) {
                      <li class="discount__item">
                        <div class="discount__info">
                          <i class="discount__icon mbi mbi-cart"></i>
                          <span class="discount__from">{{ 'global.from' | translate }}</span>
                          <div class="discount__breakpoint">
                            {{ price.costBreakpoint }} <span class="discount__currency">{{ 'global.uah' | translate }}</span>
                          </div>
                        </div>
                        <div class="discount__price" [ngClass]="i === getActivePriceIndex(item) ? 'discount__price--active' : ''">
                          {{ price.price }} <span class="item__currency">{{ 'global.uah' | translate }}</span>
                        </div>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
            <button class="item__delete" (click)="deleteFromCart(item)" type="button">
              <i class="mbi mbi-trash2"></i>
            </button>
            <div class="item__buy-info">
              @if (item.additionalServices?.length) {
                <div class="item__row">
                  @for (service of item.additionalServices; track service) {
                    <div class="item__additional-service">
                      {{ service.name }} (+{{ service.price }} {{ 'global.uah' | translate }})
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        @if (isCrossSellVisible() && i === 0) {
          <cross-sell-products class="cross-sell"
            [products]="item.crossSellProducts"
          ></cross-sell-products>
        }
      }
    </div>
  }

</div>
